import { useHistory } from "react-router-dom"

import { LocationState } from "@/protocols/history"

const useAuthReturnUrl = () => {
	const history = useHistory()

	const redirectToSignInWithReturnUrl = () => {
		history.push("/signin", { prevUrl: window.location.href })
	}

	const resolveReturnUrl = (): string | undefined => {
		const prevUrlFromState = (history.location.state as LocationState)?.prevUrl

		if (prevUrlFromState) {
			return prevUrlFromState
		}

		const returnUrlFromQuery = new URLSearchParams(window.location.search).get("returnUrl") ?? undefined

		return returnUrlFromQuery
	}

	return {
		redirectToSignInWithReturnUrl,
		resolveReturnUrl
	}
}

export default useAuthReturnUrl
